import { PAYMENT_URL } from '@cineamo/api/constants/http-constants';

import { createFetchClient } from './fetch-helper';

export const cineamoAuthClient = createFetchClient({
    baseURL: process.env.NEXT_PUBLIC_ENV_AUTH_HOST_NAME
});

export const cineamoApiClient = createFetchClient({
    baseURL: process.env.NEXT_PUBLIC_ENV_API_HOST_NAME
});

export const paymentApiClient = createFetchClient({
    baseURL: PAYMENT_URL
});
